import gsap from "gsap";

const initCpCollapser = () => {
  const collapsers = document.querySelectorAll(".cp-collapser");
  if (!collapsers.length) return;

  let mm = gsap.matchMedia();

  collapsers.forEach((collapser) => {
    const collapserButtons = collapser.querySelectorAll(".collapser-item .btn-collapser");
    const autoCollapse = collapser.classList.contains("auto-collapse");
    const allBtn = collapser.querySelectorAll('button')

    collapserButtons.forEach((button) => {
      const contentWrapper = button.nextElementSibling.querySelector('.list-wrapper');

      button.addEventListener("click", () => {
        if (autoCollapse) {
          collapserButtons.forEach((btn) => {
            if (btn === button) {
              return;
            }

            closeAllDropdowns();
            closeCollapse(btn.nextElementSibling.querySelector('.list-wrapper'));
            btn.setAttribute("aria-expanded", false);
          });
        }

        if (button.getAttribute("aria-expanded") === "false") {
    
          const tl = gsap.timeline()
          mm.add("(min-height: 625px)", () => {
            gsap.to(".img-container", { opacity: 0, height: 0, duration: 0.3, ease: "ease-out" })
          });

          gsap.to(contentWrapper, {
            height: "auto",
            opacity: 1,
            duration: 0.4,
            ease: "ease-out"
          });
          
          allBtn.forEach(btn => {
            btn.classList.remove('active')
          })

          button.classList.add('active')
          button.setAttribute("aria-expanded", true);
        } else {
          closeAllDropdowns();
          closeCollapse(contentWrapper);
          button.classList.remove('active')
          button.setAttribute("aria-expanded", false);

          mm.add("(min-height: 625px)", () => {
            gsap.to(".img-container", { opacity: 1, height: 'auto', duration: 0.4, ease: "ease-in" })
          });
        }
      });
    });
  });
};

const closeCollapse = (el) => {
  gsap.to(el, {
    height: 0,
    opacity: 0,
    duration: 0.4,
    ease: "ease-out"
  });
};

const closeAllDropdowns = () => {
  gsap.to(".container-list-lvl-three", {
      height: 0,
      opacity: 0,
      duration: 0.4,
      visibility: "hidden",
      ease: "ease-out"
  })
  document.querySelectorAll('.btn-lvl-three-dropdown').forEach(button => {
      button.classList.remove('active')
      button.setAttribute('aria-expanded', 'false')
  })
}

export default initCpCollapser;
